import { Component, Input, OnInit } from "@angular/core";
import { DataService_Student_Scan_History } from "../shared/data.service";

@Component({
	selector: "caass-student-scan-view-reminders",
	templateUrl: "./student-scan-view-reminders.component.html",
	styleUrls: ["./student-scan-view-reminders.component.css"],
})
export class StudentScanViewRemindersComponent implements OnInit {
	constructor(private ScanHistoryService: DataService_Student_Scan_History) {}

	ngOnInit(): void {
		this.loadStationReminderAlert();
	}

	ngOnChanges() {
		this.loadStationReminderAlert();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	//Input
	@Input() SelectedEntry: any;

	///////////////
	// Built-In
	///////////////

	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedStationReminderAlert: any;
	lstStationReminderAlert: any = [];

	//Filter lists
	lstAlertTypeDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		// { field: 'Message', header: 'Message' },
		// { field: 'SoundFile', header: 'Sound' },
		// { field: 'AlertTypeDesc', header: 'Occurs' },
		// { field: 'RangeDesc', header: 'Next Occurrence' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadStationReminderAlert() {
		var result = this.ScanHistoryService.StationReminderInfoSelectList(this.SelectedEntry.ScanID);
		result.subscribe(
			(response) => {
				this.lstStationReminderAlert = response;

				//Load Data Filter Lists
				this.lstAlertTypeDesc = Array.from(new Set(this.lstStationReminderAlert.map((item: any) => item.AlertTypeDesc))).sort();
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadStationReminderAlert();
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedStationReminderAlert = val.data;
	}
	onRowUnselect(val) {
		this.SelectedStationReminderAlert = null;
	}
	////////////////////////////////////////////
}
